// extracted by mini-css-extract-plugin
module.exports = {"body":"InputAddStable_body__bP5Wu","paste":"InputAddStable_paste__16zne"};